const german_translation = {
    book_now: 'Jetzt Buchen',
    loading_location_component: 'Lade Stationsdaten',
    no_access: 'Kein Zugriff',
    loading_location_component_error: 'Beim Laden der Station is ein serverseitiger Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    price_per: 'Preis pro ',
    hour: 'Stunde',
    day: 'Tag',
    week: 'Woche',
    month: 'Monat',
    quarter: 'Quartal',
    year: 'Jahr',
    ten_years: '10 Jahre',
    bikes: 'Räder',
    location: 'Standort',
    resource: 'Stellplatz',
    duration: 'Mietdauer',
    booking_until: 'Buchung bis zum',
    price: 'Preis',
    oclock: 'Uhr',
    tos_prefix: 'Ich habe die',
    tos: 'Geschäftsbedingungen',
    tos_postfix: 'gelesen und stimme ihnen zu.',
    book: 'Buchen',
    booking: 'buchen',
    email_address: 'E-Mail Adresse',
    location_free_notify_help: 'Leider ist die Anlage ausgebucht. Sie können Sich aber auf die Warteliste setzen, um informiert zu werden, sobald eine Box frei wird.',
    subscribe_to_notify_list: 'Auf Warteliste setzen',
    invalid_email: 'Bitte geben Sie eine valide E-Mail Adresse ein!',
    subscribe_to_notify_list_success: 'E-Mail erfolgreich eingetragen. Sie werden nun bei einer frei werdenden Box informiert.',
    please_choose: 'Bitte wählen',
}

export default german_translation;
